// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHealthPlanEnrollmentSummaryRecordDto
 */
export interface IHealthPlanEnrollmentSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentSummaryRecordDto
     */
    health_plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentSummaryRecordDto
     */
    plan_year?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentSummaryRecordDto
     */
    coverage_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentSummaryRecordDto
     */
    number_enrolled_in_health_plan?: number;
}

/**
 * Check if a given object implements the IHealthPlanEnrollmentSummaryRecordDto interface.
 */
export function instanceOfIHealthPlanEnrollmentSummaryRecordDto(value: object): value is IHealthPlanEnrollmentSummaryRecordDto {
    return true;
}

export function IHealthPlanEnrollmentSummaryRecordDtoFromJSON(json: any): IHealthPlanEnrollmentSummaryRecordDto {
    return IHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped(json, false);
}

export function IHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanEnrollmentSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'health_plan_name': json['health_plan_name'] == null ? undefined : json['health_plan_name'],
        'plan_year': json['plan_year'] == null ? undefined : json['plan_year'],
        'coverage_code': json['coverage_code'] == null ? undefined : json['coverage_code'],
        'number_enrolled_in_health_plan': json['number_enrolled_in_health_plan'] == null ? undefined : json['number_enrolled_in_health_plan'],
    };
}

export function IHealthPlanEnrollmentSummaryRecordDtoToJSON(json: any): IHealthPlanEnrollmentSummaryRecordDto {
    return IHealthPlanEnrollmentSummaryRecordDtoToJSONTyped(json, false);
}

export function IHealthPlanEnrollmentSummaryRecordDtoToJSONTyped(value?: IHealthPlanEnrollmentSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'health_plan_name': value['health_plan_name'],
        'plan_year': value['plan_year'],
        'coverage_code': value['coverage_code'],
        'number_enrolled_in_health_plan': value['number_enrolled_in_health_plan'],
    };
}

